import { Box, Collapse, Group, rem, Text, ThemeIcon, UnstyledButton } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { NavigationConfig } from "@/configs/@types/navigation";
import classes from "./NavigationMenu.module.css";

const NavigationMenu: React.FC<NavigationConfig> = ({
  icon: Icon,
  label,
  initiallyOpened,
  links,
  link,
}) => {
  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState<boolean>(initiallyOpened ?? false);
  const items = (hasLinks ? links : []).map((linkItem) => (
    <Text<"div"> component="div" key={linkItem.label}>
      <Link to={linkItem.link} className={classes.link}>
        {linkItem.label}
      </Link>
    </Text>
  ));

  return (
    <>
      <UnstyledButton
        component={link ? "div" : "button"}
        onClick={() => hasLinks && setOpened((opened) => !opened)}
        className={classes.control}
      >
        <Group justify="space-between" gap={0}>
          <Box style={{ display: "flex", alignItems: "center" }}>
            <ThemeIcon variant="light" size={34}>
              <Icon style={{ width: rem(20), height: rem(20) }} />
            </ThemeIcon>
            <Box ml="md">{label}</Box>
          </Box>
          {hasLinks && (
            <IconChevronRight
              className={classes.chevron}
              stroke={1.5}
              style={{
                width: rem(16),
                height: rem(16),
                transform: opened ? "rotate(-90deg)" : "none",
              }}
            />
          )}
        </Group>
      </UnstyledButton>
      {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
    </>
  );
};

export default NavigationMenu;
